<template>
  <div>
    <v-row>
      <v-col :cols="projecaoAte ? 8 : 12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="titulo-projecao-brr"
            v-model="titulo"
            class="my-0"
            label="Título*"
            outlined
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col cols="4" v-if="projecaoAte">
        <v-alert border="left" elevation="2" colored-border :type="projecaoAte ? 'success' : 'error'" class="pa-2 mx-auto" disabled>
          <b>Projeção BRR até (IPCA)</b> - {{projecaoAte | formatToMonth2}}
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
        id="select-movimentacao-blindada"
      >
        <validation-provider v-slot="{ errors }" :rules="projecaoAte ? 'required' : {required:true, forcar_erro:mensagemErrorDatasAtualizacaoDiferentes}">
          <v-text-field
            label="Movimentação da Base Homologada*"
            placeholder="Selecione uma movimentação da base homologada"
            outlined
            readonly
            prepend-icon="mdi-calendar"
            :value="movimentacaoBlindadaNome"
            :error-messages="errors"
            @focus.close="dialogSelector['MOVIMENTACAO-BLINDADA'] = true"
          />
        </validation-provider>
        <dialog-seletor-movimentacao-blindada
          :activated.sync="dialogSelector['MOVIMENTACAO-BLINDADA']"
          incluirDataAtualizarAte
          @selected="setDataSelector('MOVIMENTACAO-BLINDADA', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
        id="select-simulacao-laudo-express"
      >
      <validation-provider v-slot="{ errors }" :rules="projecaoAte ? 'required' : {required:true, forcar_erro:mensagemErrorDatasAtualizacaoDiferentes}">
          <v-text-field
            label="Simulação de Laudo Express*"
            placeholder="Selecione uma simulação de laudo express"
            outlined
            readonly
            prepend-icon="mdi-calendar"
            :value="simulacaoLaudoIncrementalNome"
            :error-messages="errors"
            @focus.close="dialogSelector['SIMULACAO-LAUDO-INCREMENTAL'] = true"
          />
        </validation-provider>
        <dialog-seletor-simulacao-laudo-incremental
          :activated.sync="dialogSelector['SIMULACAO-LAUDO-INCREMENTAL']"
          incluirDataSimulacaoLaudo
          @selected="setDataSelector('SIMULACAO-LAUDO-INCREMENTAL', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
        id="select-predicao-baixas"
      >
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            label="Predição de Baixas*"
            placeholder="Selecione uma predição de baixas"
            outlined
            readonly
            persistent-hint
            prepend-icon="mdi-calendar"
            :value="predicaoBaixasNome"
            :error-messages="errors"
            :disabled="!(simulacaoLaudoIncrementalId && movimentacaoBlindadaId)"
            :hint="!(simulacaoLaudoIncrementalId && movimentacaoBlindadaId) ? 'Antes de selecionar a predição de baixas escolha a movimentação da base homologada e a simulação de laudo express que irão compor a projeção' : ''"
            @focus.close="dialogSelector['PREDICAO-BAIXAS'] = true"
          />
        </validation-provider>
        <dialog-seletor-predicao-baixas
          v-if="movimentacaoBlindadaDataBase"
          :activated.sync="dialogSelector['PREDICAO-BAIXAS']"
          filtroBase="LAUDO"
          :filtroDataBase="movimentacaoBlindadaDataBase"
          :filtroCenarioVinculado="true"
          @selected="setDataSelector('PREDICAO-BAIXAS', $event)"
        />
      </v-col>
    </v-row>
    <v-divider class="mb-4" />
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header
          id="arquivo-capex-projecao-brr"
        >
          <label style="font-size: 15px !important">Arquivo CAPEX</label>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="getArquivoModelo()">Clique aqui</a> para baixar o modelo para a importação.
                  <br>OBS: O arquivo deve conter as seguintes colunas: <b>{{cabecalhoArquivoCapex.join(', ')}}</b> (exatamente nessa ordem e com esses nomes).
                  <br>OBS²: O arquivo enviado precisa estar no formato <b>UTF-8</b>.
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-file-input
                  v-model="arquivoCapexFileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv, .zip"
                  truncate-length="30"
                  :loading="arquivoCapexUploading"
                  loader-height="4"
                  :success="arquivoCapexId && arquivoCapexFileObj ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFile($event)"
                  @click:clear="clearInputsArquivoCapex()"
                />
              </validation-provider>
              <validation-provider rules="required">
                <input type="hidden" name="validate-upload-arquivo-capex" :value="arquivoCapexId" />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row class="mx-auto mt-n2 mb-n5">
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv 
                :delimitador.sync="arquivoCapexDelimitador"
                :involucro.sync="arquivoCapexInvolucro"
                :escape.sync="arquivoCapexEscape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import ProjecaoBrrService from '@/services/ProjecaoBrrService';
import ArquivosService from "@/services/ArquivosService";

export default {
  components: {
    DialogSeletorMovimentacaoBlindada:      () => import("@/components/general/selectors/GeneralDialogSeletorMovimentacaoBlindada.vue"),
    DialogSeletorSimulacaoLaudoIncremental: () => import("@/components/general/selectors/GeneralDialogSeletorSimulacaoLaudoIncremental.vue"),
    DialogSeletorPredicaoBaixas:            () => import("@/components/general/selectors/GeneralDialogSeletorPredicaoBaixas.vue"),
    ParametrosArquivoCsv:                   () => import("@/components/general/GeneralParametrosArquivoCsv.vue")
  },

  mounted() {
    if (this.$route.params.id) this.abrirPainel();
    this.getUltimoIpca();
  },

  data: () => ({
    dialogSelector: {'MOVIMENTACAO-BLINDADA': false, 'SIMULACAO-LAUDO-INCREMENTAL': false, 'PREDICAO-BAIXAS': false},
    cabecalhoArquivoCapex: [
      'Tipo',
      'Valor',
      'VNR/VOC',
      'Competencia'
    ],
    panel: false,
    datasInvalidas: false,
    ultimoIpca: ''
  }),

  computed: {
    titulo: {
      get () { return this.$store.state.projecaoBrr.titulo},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'titulo': value})}
    },
    dataBase: {
      get () { return this.$store.state.projecaoBrr.dataBase},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'dataBase': value})}
    },
    movimentacaoBlindadaId: {
      get () { return this.$store.state.projecaoBrr.movimentacaoBlindada.id},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'movimentacaoBlindada': {'id': value}})}
    },
    movimentacaoBlindadaNome: {
      get () { return this.$store.state.projecaoBrr.movimentacaoBlindada.nome},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'movimentacaoBlindada': {'nome': value}})}
    },
    movimentacaoBlindadaDataBase: {
      get () { return this.$store.state.projecaoBrr.movimentacaoBlindada.data_base},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'movimentacaoBlindada': {'data_base': value}})}
    },
    movimentacaoBlindadaAtualizarAte: {
      get () { return this.$store.state.projecaoBrr.movimentacaoBlindada.atualizar_ate},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'movimentacaoBlindada': {'atualizar_ate': value}})}
    },
    simulacaoLaudoIncrementalId: {
      get () { return this.$store.state.projecaoBrr.simulacaoLaudoIncremental.id},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'simulacaoLaudoIncremental': {'id': value}})}
    },
    simulacaoLaudoIncrementalNome: {
      get () { return this.$store.state.projecaoBrr.simulacaoLaudoIncremental.nome},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'simulacaoLaudoIncremental': {'nome': value}})}
    },
    simulacaoLaudoIncrementalDataBase: {
      get () { return this.$store.state.projecaoBrr.simulacaoLaudoIncremental.data_base},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'simulacaoLaudoIncremental': {'data_base': value}})}
    },
    simulacaoLaudoIncrementalDataSimulacao: {
      get () { return this.$store.state.projecaoBrr.simulacaoLaudoIncremental.data_simulacao_laudo},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'simulacaoLaudoIncremental': {'data_simulacao_laudo': value}})}
    },
    predicaoBaixasId: {
      get () { return this.$store.state.projecaoBrr.predicaoBaixas.id},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'predicaoBaixas': {'id': value}})}
    },
    predicaoBaixasNome: {
      get () { return this.$store.state.projecaoBrr.predicaoBaixas.nome},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'predicaoBaixas': {'nome': value}})}
    },
    predicaoBaixasDataBase: {
      get () { return this.$store.state.projecaoBrr.predicaoBaixas.data_base},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'predicaoBaixas': {'data_base': value}})}
    },
    arquivoCapexId: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.id},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'id': value}})}
    },
    arquivoCapexFileObj: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.fileObj},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'fileObj': value}})}
    },
    arquivoCapexUploading: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.uploading},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'uploading': value}})}
    },
    arquivoCapexDelimitador: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.delimitador},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'delimitador': value}})}
    },
    arquivoCapexInvolucro: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.involucro},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'involucro': value}})}
    },
    arquivoCapexEscape: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.escape},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'escape': value}})}
    },
    arquivoCapexFakeFile: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.fakeFile},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'fakeFile': value}})}
    },
    arquivoCapexHeaderValido: {
      get () { return this.$store.state.projecaoBrr.arquivoCapex.headerValido},
      set (value) { this.$store.dispatch('setProjecaoBrr', {'arquivoCapex': {'headerValido': value}})}
    },
    datasAtualizacaoIguais() {
      return this.movimentacaoBlindadaAtualizarAte == this.simulacaoLaudoIncrementalDataSimulacao;
    },
    projecaoAte() {
      let data = null;

      if (this.movimentacaoBlindadaAtualizarAte && !this.simulacaoLaudoIncrementalDataSimulacao) {
        data = this.movimentacaoBlindadaAtualizarAte;
      } else if (this.simulacaoLaudoIncrementalDataSimulacao && !this.movimentacaoBlindadaAtualizarAte) {
        data = this.simulacaoLaudoIncrementalDataSimulacao; 
      } else if (this.datasAtualizacaoIguais) {
        data = this.movimentacaoBlindadaAtualizarAte;
      }

      return data;
    },

    mensagemErrorDatasAtualizacaoDiferentes() {
      let dataMB = this.formatToMonth(this.movimentacaoBlindadaAtualizarAte);
      let dataSLI = this.formatToMonth(this.simulacaoLaudoIncrementalDataSimulacao);

      return `Valor invalido, as datas de atualizações da movimentação da base homologada [${dataMB}] e da simulação de laudo express [${dataSLI}] são diferentes`;
    }
  },

  methods:{
    getUltimoIpca() {

      ProjecaoBrrService.getUltimoIpca()
        .then(({ data }) => {
          this.ultimoIpca = this.formatToMonth(data.ipca.data_registro);
        })
        .catch(err => {
          this.$toast.error("Erro ao buscar o último IPCA", "", { position: "topRight"});
          console.error(err);
        })
    },

    setDataSelector(tipo, event) {
      switch (tipo) {
        case 'MOVIMENTACAO-BLINDADA':
          this.clearPredicao();
          this.movimentacaoBlindadaId = event.id;
          this.movimentacaoBlindadaNome = `#${event.id} - ${event.titulo}${event.versao ? ` (${/^v/i.test(event.versao) ? event.versao : `v${event.versao}`})` : ''}`;
          this.movimentacaoBlindadaDataBase = event.data_base;
          this.movimentacaoBlindadaAtualizarAte = event.atualizar_ate;
          break;
        case 'SIMULACAO-LAUDO-INCREMENTAL':
          this.simulacaoLaudoIncrementalId = event.id;
          this.simulacaoLaudoIncrementalNome = `#${event.id} - ${event.titulo}`;
          this.simulacaoLaudoIncrementalDataBase = event.data_base;
          this.simulacaoLaudoIncrementalDataSimulacao = event.data_simulacao_laudo;
          break;
        case 'PREDICAO-BAIXAS':
          this.predicaoBaixasId = event.id;
          this.predicaoBaixasNome = `#${event.id} - ${event.titulo}`;
          this.predicaoBaixasDataBase = event.data_base;
          break;
      }

      this.dialogSelector[tipo] = false;
    },

    clearPredicao() {
      this.predicaoBaixasId = null;
      this.predicaoBaixasDataBase = null;
      this.predicaoBaixasNome = '';
    },

    getArquivoModelo() {
      this.$toast.info("Processando...", "", { position: "topRight", timeout: 1250 });

      ProjecaoBrrService.getArquivoModeloCapex()
        .then(async res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", `Arquivo CAPEX Modelo.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Erro ao baixar arquivo modelo do sistema", "", { position: "topRight"});
          console.error(err);
        })
    },

    clearInputsArquivoCapex() {
      this.arquivoCapexId = "";
      this.arquivoCapexFileObj = null;
      this.arquivoCapexDelimitador = ";";
      this.arquivoCapexInvolucro = `"`;
      this.arquivoCapexEscape = `"`;
      this.arquivoCapexFakeFile = false;
      this.arquivoCapexHeaderValido = false;

      this.$forceUpdate();
    },

    uploadNewFile(arquivo) {
      if (!arquivo) {
        this.clearInputsArquivoCapex();
        return true;
      }

      this.arquivoCapexFakeFile = false;
      this.arquivoCapexId = "";
      this.arquivoCapexUploading = true;
      
      let formDataWithFile = new FormData();
      formDataWithFile.append("file", arquivo);

      ArquivosService.uploadFile(formDataWithFile, {})
        .then(async response => {
          await this.validaHeader(
            response.data.arquivoId,
            this.arquivoCapexDelimitador,
            this.arquivoCapexInvolucro,
            this.arquivoCapexEscape,
            this.cabecalhoArquivoCapex
          );
          await this.validaIpcaArquivoCapex(
            response.data.arquivoId,
            this.arquivoCapexDelimitador,
            this.arquivoCapexInvolucro,
            this.arquivoCapexEscape,
            this.ultimoIpca
          );
          this.arquivoCapexId = response.data.arquivoId;
        })
        .catch((err) => {
          if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
            this.$toast.error(err.data.erro, "", { position: "topRight", timeout: 6000 });
          } else {
            this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" });
            console.error("Erro ao fazer upload: ", err);
          }

          this.arquivoCapexFileObj = null;
        })
        .finally(() => this.arquivoCapexUploading = false);
    },

    validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado,) {
      return ArquivosService.validarHeaderCSV(arquivoId, { delimitador, involucro, escape, cabecalhoEsperado })
        .catch(err => { throw err });
    },

    validaIpcaArquivoCapex(arquivoId, delimitador, involucro, escape, ultimoIpca) {  
      return ProjecaoBrrService.validaIpcaArquivoCapex({arquivoId, delimitador, involucro, escape, ultimoIpca})
        .catch(err => { throw err });
    },

    abrirPainel() {
      this.panel = 0;
    },

    formatToMonth(data) {
      if (!data) return null;

      const [year, month] = data.split('-');
      return `${month}/${year}`;
    },

    exportData() {
      const vuexData = this.$store.state.projecaoBrr;

      return {
        id: this.$route.params.id ? this.$route.params.id : null,
        titulo: vuexData.titulo,
        movimentacao_blindada_id: vuexData.movimentacaoBlindada.id,
        simulacao_laudo_incremental_id: vuexData.simulacaoLaudoIncremental.id,
        predicao_baixas_id: vuexData.predicaoBaixas.id,
        arquivo_capex_id: vuexData.arquivoCapex.id,
        arquivo_capex_delimitador: vuexData.arquivoCapex.delimitador,
        arquivo_capex_involucro: vuexData.arquivoCapex.involucro,
        arquivo_capex_escape: vuexData.arquivoCapex.escape
      };
    }
  }
}
</script>
